export default __webpack_public_path__ + "static/media/sporange.a549fa14.png";